export default "__VITE_PUBLIC_ASSET__36dfa62b__"